module.exports = __webpack_public_path__ + "web/img/aac.8d929590.png";